import React, {useEffect, useState} from 'react';
import {getHeaderNotification,  getFaqsData} from './../utils/endpoints'
import HeaderNotification from './components/headerNotification';
import Loading from './components/loading';
import Header from './components/header';
import Footer from './components/footer';
import { Container} from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import file01 from '../assets/pdf/notice-of-general-meeting/2013.10.25_Notice of EGM_Tatpadam-Upavan.pdf'
import file02 from '../assets/pdf/notice-of-general-meeting/2013.12.16_Notice of EGM_Tatpadam-Upavan.pdf'
import file03 from '../assets/pdf/notice-of-general-meeting/2014.03.26_Notice of EGM_Tatpadam-Upavan.pdf'
import file04 from '../assets/pdf/notice-of-general-meeting/2014.09.08_Notice of 01st AGM_Tatpadam-Upavan.pdf'
import file05 from '../assets/pdf/notice-of-general-meeting/2015.09.29_Notice of 02nd AGM_Tatpadam-Upavan.pdf'
import file06 from '../assets/pdf/notice-of-general-meeting/2016.03.29_Notice of 01st EGM of 2015-16_Tatpadam-Upavan.pdf'
import file07 from '../assets/pdf/notice-of-general-meeting/2016.09.26_Notice of 03rd AGM_Tatpadam-Upavan.pdf'
import file08 from '../assets/pdf/notice-of-general-meeting/2017.09.25_Notice of 04th AGM_Tatpadam-Upavan.pdf'
import file09 from '../assets/pdf/notice-of-general-meeting/2018.05.09_Notice of 01st EGM of 2018-19_Tatpadam-Upavan.pdf'
import file10 from '../assets/pdf/notice-of-general-meeting/2018.09.15_Notice of 05th AGM_Tatpadam-Upavan.pdf'
import file11 from '../assets/pdf/notice-of-general-meeting/2019.09.28_Notice of 06th AGM_Tatpadam-Upavan.pdf'
import file12 from '../assets/pdf/notice-of-general-meeting/2020.04.01_Notice of 01st EGM of 2020-21_Tatpadam-Upavan.pdf'
import file13 from '../assets/pdf/notice-of-general-meeting/2020.11.23_Notice of 07th AGM_Tatpadam-Upavan.pdf'
import file14 from '../assets/pdf/notice-of-general-meeting/2021.11.22_Notice of 08th AGM_Tatpadam-Upavan.pdf'
import file15 from '../assets/pdf/notice-of-general-meeting/2022.03.31_Notice of 01st EGM 2021-22_Tatpadam-Upavan.pdf'
import file16 from '../assets/pdf/notice-of-general-meeting/2022.09.26_Notice of 09th AGM_Tatpadam-Upavan.pdf'
import file17 from '../assets/pdf/notice-of-general-meeting/2023.01.16_Notice of 01st EGM 2022-23_Tatpadam-Upavan.pdf'
import file18 from '../assets/pdf/notice-of-general-meeting/2023.04.24_Notice of 1st EGM of 2023-24_Tatpadam-Upavan.pdf'
import file19 from '../assets/pdf/notice-of-general-meeting/2023.09.27_Notice of 10th AGM_Tatpadam-Upavan.pdf'
import file20 from '../assets/pdf/notice-of-general-meeting/2024.09.30_Notice of 11th AGM_Tatpadam-Upavan.pdf'


const NoticeOfGeneralMeeting = () => {
  const [headerNotificationData, setheaderNotificationData] = useState(null);
  const [faqs, setFaqs] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const faqs = await getFaqsData();
        const headerNotificationData = await getHeaderNotification();
        setheaderNotificationData(headerNotificationData);
        setFaqs(faqs);
        
        setIsLoading(false);
      } catch (error) {
        setError(error);
        setIsLoading(false);
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const faQSlice = faqs;

  if (isLoading) {
    return <div><Loading /></div>;
  }

  if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      <Helmet>
      <title>Notice of General Meeting | Investors | Statue of Belief</title>
      </Helmet>
      <HeaderNotification compData={headerNotificationData}/>
      <Header />
      <section className='section-breadcrumb'>
      <Container>
      <ul>
            <li><a href="/">Home</a></li>
            <li>Notice of General Meeting</li>
        </ul>
        <h1>Notice of General Meeting</h1>
      </Container>
    </section>
    <section className='section-about'>
    <Container>
      <h2 class="mb-3">Notice of General Meeting</h2>
        <ul className='list-item'>
            <li><a href={file01} download>2013.10.25_Notice of EGM_Tatpadam-Upavan</a></li>
            <li><a href={file02} download>2013.12.16_Notice of EGM_Tatpadam-Upavan</a></li>
            <li><a href={file03} download>2014.03.26_Notice of EGM_Tatpadam-Upavan</a></li>
            <li><a href={file04} download>2014.09.08_Notice of 01st AGM_Tatpadam-Upavan</a></li>
            <li><a href={file05} download>2015.09.29_Notice of 02nd AGM_Tatpadam-Upavan</a></li>
            <li><a href={file06} download>2016.03.29_Notice of 01st EGM of 2015-16_Tatpadam-Upavan</a></li>
            <li><a href={file07} download>2016.09.26_Notice of 03rd AGM_Tatpadam-Upavan</a></li>
            <li><a href={file08} download>2017.09.25_Notice of 04th AGM_Tatpadam-Upavan</a></li>
            <li><a href={file09} download>2018.05.09_Notice of 01st EGM of 2018-19_Tatpadam-Upavan</a></li>
            <li><a href={file10} download>2018.09.15_Notice of 05th AGM_Tatpadam-Upavan</a></li>
            <li><a href={file11} download>2019.09.28_Notice of 06th AGM_Tatpadam-Upavan</a></li>
            <li><a href={file12} download>2020.04.01_Notice of 01st EGM of 2020-21_Tatpadam-Upavan</a></li>
            <li><a href={file13} download>2020.11.23_Notice of 07th AGM_Tatpadam-Upavan</a></li>
            <li><a href={file14} download>2021.11.22_Notice of 08th AGM_Tatpadam-Upavan</a></li>
            <li><a href={file15} download>2022.03.31_Notice of 01st EGM 2021-22_Tatpadam-Upavan</a></li>
            <li><a href={file16} download>2022.09.26_Notice of 09th AGM_Tatpadam-Upavan</a></li>
            <li><a href={file17} download>2023.01.16_Notice of 01st EGM 2022-23_Tatpadam-Upavan</a></li>
            <li><a href={file18} download>2023.04.24_Notice of 1st EGM of 2023-24_Tatpadam-Upavan</a></li>
            <li><a href={file19} download>2023.09.27_Notice of 10th AGM_Tatpadam-Upavan</a></li>
            <li><a href={file20} download>2024.09.30_Notice of 11th AGM_Tatpadam-Upavan</a></li>
        </ul>
    </Container>
    </section>
    <Footer />
    </div>
  );
};

export default NoticeOfGeneralMeeting;